/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {


	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
		
			finalize: function() {
			
				$(function () {
					$('[data-toggle="tooltip"]').tooltip();
				});

				$("#hero-banner").owlCarousel({
					loop: true,
					margin: 0,
					nav: true,
					items: 1,
					dots: false,
					autoplay : true,
					autoplayTimeout : 6500,
					autoplaySpeed:500,
					dotsEach : false,
					navText: [" "," "],
					animateOut: "fadeOut",
					responsive: {
						0: {
							nav:false,
							dots:true
						},
						768: {
							nav:true,
							dots:false
						},
						992: {
							nav:true,
							dots:false
						}
					}
				});
				
				$("#acc_banner").owlCarousel({
					loop: true,
					// margin: 0,
					nav: false,
					dots: true,
					autoWidth:true,
					items:6,
					autoplay : true,
					autoplayTimeout : 100,
					autoplaySpeed: 1500,
					dotsEach : false,
					animateIn: "fadeIn",
					animateOut: "fadeOut",
					responsive: {
						0: {
							items: 1,
							stagePadding:60,
							loop:false,
							autoplay:false
						},
						768: {
							items: 3	
						},
						992: {
							items: 6
						}
					}
				});
				
				$("#news_banner,#related-banner").owlCarousel({
					loop: true,
					nav: true,
					dots: true,
					autoplay : true,
					autoplayTimeout : 6500,
					autoplaySpeed:500,
					dotsEach : false,
					navText: [" "," "],
					responsive : {
						0: {
							nav:false,
							items:1,
							margin:30,
							loop:false,
							autoplay:false,
							slideBy:1
						},
						768: {
							nav:false,
							items:1,
							margin:30,
							stagePadding:150,
							loop:false,
							autoplay:false,
							slideBy:2
						},
						992: {
							items:2,
							margin:30,
							nav:true,
							slideBy:2
						}
					}
				});
				
				$('#back_to_top').click(function(e) {
					e.preventDefault();
					$(".body-outer").animate({ scrollTop: 0 }, "slow");
				});
				
				$('.article-list-outer .article-case-list .article .details-outer .title').matchHeight();
				$('.article-list-outer .article-case-list .article .details-outer .tags').matchHeight();
				
				$('.latest-news .news-banner .slider-item .details-outer .title').matchHeight();
			
				$('.related-box .related-articles .article-box .details-outer .title').matchHeight();
			
				$('.sb-child-pages ul li .arrow').click(function() {
					id = $(this).parent('li').attr('data-id');
					$(this).toggleClass('opened');
					$(this).parent('li').toggleClass('opened');
					$('.sb-child-pages ul .sub-pages[data-id="'+id+'"]').slideToggle('fast');
				});
				
				$('.sb-child-pages ul .sub-pages li').each(function() {
					if ($(this).hasClass('active')) {
						id = $(this).attr('data-id');
						$('.sb-child-pages ul li[data-id="'+id+'"] .arrow').addClass('opened');
						$('.sb-child-pages ul li[data-id="'+id+'"]').addClass('opened');
						$('.sb-child-pages ul .sub-pages[data-id="'+id+'"]').show();
					}	
				});
				
				
				$('.staff-list .staff-box .view-profile,.staff-list .staff-box .image,.staff-list .staff-box .name').click(function() {
					id = $(this).attr('data-id');
					$('.staff-list .staff-box').each(function() {
						if( $(this).attr('data-id') != id ) {
							$(this).addClass('greyed');
						}
					});
					
					pos = $('.staff-list .staff-box .view-profile[data-id="'+id+'"]').position();
					box_pos = $('.staff-list .staff-box[data-id="'+id+'"]').parent('.parentbox').position();
					
					$('.staff-list .overlay[data-id="'+id+'"]').css('top',pos.top+40+box_pos.top);	
					$('.staff-list .overlay[data-id="'+id+'"]').show('fast',function() {
						newheight = $('.staff-list .overlay[data-id="'+id+'"]').height();
						if($('.staff-list').height() < (newheight+box_pos.top+pos.top+40)) {
							$('.staff-list').css('height',newheight+box_pos.top+pos.top+40);
						}
					});
				});
				
				$('.staff-list .overlay .close-button').click(function() {
					id = $(this).attr('data-id');
					$('.staff-list .overlay[data-id="'+id+'"]').hide('slow');
					$('.staff-list').css('height','auto');
					$('.staff-list .staff-box').each(function() {
						$(this).removeClass('greyed');
					});
					
				});
				
				$('.responsive-menu-bar .top-bar .menu .burger-btn,.responsive-menu-bar .top-bar .menu .caption').click(function() {
					$(this).toggleClass('opened');
					$('.responsive-nav').slideToggle('middle');
				});
				
				
				$('.sb-child-pages ul li.parent .arrow').click(function() {
					$(this).parent('li').parent('ul').children('li').toggle();
					$(this).toggleClass('opened');
					//$(this).parent('li').parent('ul').children('.sub-pages').toggle();
				});
				
				$('#submitBtn').click(function(e) {
					e.preventDefault();
					$('#email').val($('#pre_email').val());
				});
				
				$('#nl-submit').click(function(e) {
					e.preventDefault();
					//$('#newsletter-signup').submit();
					var data = {
						'action' : 'kt_subscribe',
						'first_name': $('input[name="first_name"]').val(),
						'last_name': $('input[name="last_name"]').val(),
						'email':$('input[name="email"]').val()
					};
					//AJAX REQUEST HERE 
					$.post(ajaxurl,data,function(response) {
						response = $.parseJSON(response);
						if (response.success == false) {
							$('#modal_message').html(response.message);
							$('#modal_message').slideDown();
						} else {
							$('#modal_message').html(response.message);
							$('#modal_message').slideDown('slow');
							setTimeout(function() {
								$('#confirm-submit').modal('hide');
							}, 4000);
							
						}
						console.log(response);
					});
				});
				
			}
		}
	};

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
